var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import urlUtils from "./UrlUtils.js";
import { filter, map, tap, ignoreElements } from "rxjs/operators";
import RouteUpdateConstants from "./RouteUpdateConstants.js";
import { ofType } from "redux-observable";
function produceUserContextRouteQueryStringEpics(userContextParams, setUserContext, setPartialUserContextActionType, setUserContextactionActionType, userContextFromStore, history, isRoutePathSupported, additionalFixedParams) {
  const setUserContextFromQueryString = (action$) => {
    return action$.pipe(
      ofType(RouteUpdateConstants.ROUTE_UPDATE),
      filter((loc) => isRoutePathSupported(loc.payload.pathname)),
      map((action) => {
        const userContext = urlUtils.getUserContextFromUrl(userContextParams, action.payload.search);
        return setUserContext(userContext);
      })
    );
  };
  const setUserContextFromPartial = (action$, state$) => {
    return action$.pipe(
      ofType(setPartialUserContextActionType),
      map((action) => {
        const newContext = __spreadValues(__spreadValues({}, userContextFromStore(state$.value)), action.payload);
        return setUserContext(newContext);
      })
    );
  };
  const setQueryStringFromUserContext = (action$) => {
    return action$.pipe(
      ofType(setUserContextactionActionType),
      // update the URL based on the user context
      tap((x) => {
        var _a, _b;
        const queryStringParams = urlUtils.getUrlFromUserContext(
          userContextParams,
          additionalFixedParams,
          x.payload,
          history.location.search
        );
        const queryStringWithoutStartingQ = (_b = (_a = history == null ? void 0 : history.location) == null ? void 0 : _a.search) == null ? void 0 : _b.trim().replace(/^[?]/, "");
        if (queryStringWithoutStartingQ !== queryStringParams) {
          if (!!x.shouldReplace) {
            history.replace({
              search: queryStringParams
            });
          } else {
            history.push({
              search: queryStringParams
            });
          }
        }
      }),
      ignoreElements()
    );
  };
  return { setUserContextFromQueryString, setUserContextFromPartial, setQueryStringFromUserContext };
}
export {
  produceUserContextRouteQueryStringEpics
};
//# sourceMappingURL=ProduceUserContextRouteQueryStringEpics.js.map
